import React from 'react';
import { useEmployeePermissionsFreshness } from '../session/hooks/useEmployeePermissionsFreshness';

/** Side-effect provider: poll de permissions_updated_at (Equipo Slice 2). */
export function EmployeePermissionsFreshnessProvider({ children }: { children: React.ReactNode }) {
  useEmployeePermissionsFreshness();
  return <>{children}</>;
}
